// src/dialog/dialog-context.ts
import { createContext } from "react";
var DialogContext = createContext(void 0);
var DialogHeadingContext = createContext(void 0);
var DialogDescriptionContext = createContext(void 0);

export {
  DialogContext,
  DialogHeadingContext,
  DialogDescriptionContext
};
